console.log("custom product");

document.addEventListener("DOMContentLoaded", function () {
  const plusButton = document.querySelector(".plus_button");
  const minusButton = document.querySelector(".minus_button");
  const refreshButton = document.querySelector(".refresh_button"); // Assuming you have a refresh button

  function handleButtonClick(event) {
    event.preventDefault(); // Prevent the default action of the button
    const forms = document.querySelectorAll('form[action="/cart/add"]');

    forms.forEach((form) => {
      let formData = new FormData(form);
      checkCartTotal(form, formData);
    });
  }

  plusButton.addEventListener("click", handleButtonClick);
  minusButton.addEventListener("click", handleButtonClick);

  // Event handler for the refresh button
  refreshButton.addEventListener("click", function() {
    refreshButton.textContent = "Refreshing..."; // Change button text
    location.reload(); // Refresh the page
  });

  // Set an interval to automatically click the refresh button every 10 minutes
  setInterval(function() {
    refreshButton.click(); // Trigger the click event on the refresh button
  }, 600000); // 600,000 milliseconds = 10 minutes

  function checkCartTotal(form, formData) {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        let cartTotal = cart.total_price;
        console.log(cartTotal);
        const productInfoContainer = document.querySelector(".product__info-container");

        if (productInfoContainer) {
          const productPrice = parseInt(productInfoContainer.getAttribute("data-price-pence"));
          console.log("Price in Pence:" + productPrice);

          let quantity = parseInt(formData.get("quantity")) || 1;
          let newProductTotalPrice = productPrice * quantity;
          cartTotal += newProductTotalPrice;
          cartTotal = cartTotal / 100; // Convert the total to pounds

          updateCartUI(cartTotal);
        }
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  }

  function updateCartUI(cartTotal) {
    const cartFullDiv = document.querySelector(".cart-full");
    const submitButton = document.querySelector(".product-form__submit");

    if (cartTotal > 8000) {
      console.log("Cart total exceeds £8000");
      cartFullDiv.style.display = "block";
      submitButton.style.display = "none";
      plusButton.disabled = true;
      plusButton.classList.add("disabled");
    } else {
      cartFullDiv.style.display = "none";
      submitButton.style.display = "block";
      plusButton.disabled = false;
      plusButton.classList.remove("disabled");
    }
  }
});
